import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSettings } from "@/lib/SettingsContext";

export default function ConsultationBand({ subline }) {
  const { settings } = useSettings();
  const hasCalendly = Boolean(settings.calendly_url);

  return (
    <section
      data-testid="consultation-band"
      className="wt-section"
      style={{ backgroundColor: "var(--wt-primary)" }}
    >
      <div className="wt-container">
        <div className="max-w-3xl mx-auto text-center">
          <div className="flex items-center justify-center gap-3">
            <span
              className="h-px w-8"
              style={{ backgroundColor: "var(--wt-gold)" }}
              aria-hidden="true"
            />
            <span
              className="text-[11px] font-semibold tracking-[0.18em] uppercase"
              style={{ color: "rgba(250,247,240,0.7)" }}
            >
              Two ways to begin
            </span>
            <span
              className="h-px w-8"
              style={{ backgroundColor: "var(--wt-gold)" }}
              aria-hidden="true"
            />
          </div>
          <h2
            className="mt-5 font-serif font-semibold leading-tight"
            style={{
              color: "var(--wt-bg)",
              fontSize: "clamp(1.75rem, 1.2rem + 2.4vw, 2.5rem)",
              letterSpacing: "-0.01em",
            }}
          >
            {subline ||
              "Book a consultation, or invite Wanakee to speak."}
          </h2>
          <p
            className="mt-4 text-base sm:text-lg leading-relaxed"
            style={{ color: "rgba(250,247,240,0.86)" }}
          >
            District-respected, substantive, and built to convert conversation into the next
            structured step.
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/book-consultation"
              data-testid="band-book-consultation"
              className="inline-flex items-center justify-center gap-2 h-12 px-7 rounded-md text-sm font-semibold"
              style={{
                backgroundColor: "var(--wt-bg)",
                color: "var(--wt-ground)",
                boxShadow: "inset 0 0 0 1px rgba(201,162,39,0.45)",
              }}
            >
              Book a Consultation
              <ArrowRight size={16} aria-hidden="true" />
            </Link>
            <Link
              to="/book-speaking"
              data-testid="band-book-speaking"
              className="inline-flex items-center justify-center gap-2 h-12 px-7 rounded-md text-sm font-semibold"
              style={{
                backgroundColor: "transparent",
                color: "var(--wt-bg)",
                border: "1px solid rgba(250,247,240,0.5)",
              }}
            >
              Book Me to Speak
            </Link>
          </div>
          {!hasCalendly && (
            <p className="mt-5 text-xs" style={{ color: "rgba(250,247,240,0.6)" }}>
              Booking opens through a direct inquiry while the calendar is being connected.
            </p>
          )}
        </div>
      </div>
    </section>
  );
}

ConsultationBand.propTypes = {
  subline: PropTypes.string,
};
